module.exports = __webpack_public_path__ + "media/images/logos/icmje_logo-9f1e554700d5fe5cc0b0ad0a630500b9.png";